import { Box, Button, Divider, LinearProgress, TextField, Typography } from '@mui/material';
import { FileInterface } from '../../../services/api/minio/Minio';
import { Download, UploadFile } from '@mui/icons-material';
import SelectTypeFile from '../../shared/SelectTypeFile';
import { SelectNpgb } from '../../shared/SelectNpgb';

interface FormFileProps {
	data: FileInterface | null,
	onChange: (key: keyof FileInterface, value: string) => void;
	onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	error: boolean;
	edit: boolean;
	download: () => void;
}

export function FormFile({
	data,
	onChange,
	onFileChange,
	error,
	edit,
	download
}: FormFileProps) {


	if (data === null) return (<LinearProgress />);

	return (
		<Box sx={{ padding: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
			<Typography variant='h6'>1 - Selecione o arquivo</Typography>
			<div>
				{edit === true ? (
					<Button onClick={download} component="label" role={undefined} variant="contained" tabIndex={-1} startIcon={<Download />} htmlFor="file-input" sx={{ borderRadius: '25px' }}>
						Download
					</Button>
				) : (
					<Button disabled={edit} component="label" role={undefined} variant="contained" tabIndex={-1} startIcon={<UploadFile />} htmlFor="file-input" sx={{ borderRadius: '25px' }}>
						{data.file?.name ? data.file?.name : 'Selecionar arquivo'}
						<input required id="file-input" type="file" onChange={onFileChange} hidden accept='.pdf,application/pdf' />
					</Button>
				)}
				{error && data.file === null &&
					<Typography variant='body1' color='red'>Selecione um arquivo.</Typography>
				}
			</div>

			<Divider />
			<Typography variant='h6'>2 - Informações do arquivo</Typography>
			<TextField
				label='Descrição'
				onChange={(e) => onChange('descricao', e.target.value)}
				minRows={3}
				rows={3}
				fullWidth
				value={data.descricao}
				InputLabelProps={{ shrink: true }}
			/>
			<TextField
				label='Data de emissão'
				onChange={(e) => onChange('data_emissao', e.target.value)}
				fullWidth
				value={data.data_emissao}
				InputLabelProps={{ shrink: true }}
				error={error && data.data_emissao == ''}
				type='month'
			/>
			<SelectTypeFile
				onChange={(e) => onChange('tipo', e)}
				value={data.tipo}
				error={error && data.tipo == ''}
			/>
			{(data.tipo === 'Relatório de Inspeção de Segurança Regular' || data.tipo === 'Relatório de Inspeção de Segurança de Rotina') && (
				<SelectNpgb onChange={(e) => onChange('npgb', e)} value={data.npgb ?? ''} />
			)}
			<Divider />
		</Box>
	);
}
